import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessControlDirective } from './directives/access-control.directive';
import { SafePipe } from './pipes/safe.pipe';
import { AllArchPipe } from './pipes/allArch.pipe';
import { DragDirective } from './directives/drag-and-drop-file.directive';
import { StlViewerComponent } from './components/stl-viewer/stl-viewer.component';



@NgModule({
  declarations: [
  AccessControlDirective,
  SafePipe,
    DragDirective,
  AllArchPipe,
  StlViewerComponent
],
  imports: [
    CommonModule
  ],
  exports: [
    AccessControlDirective,
    DragDirective,
    SafePipe,
    AllArchPipe,
    StlViewerComponent
  ]
})
export class SharedModule { }
